// ---------------------------------------------------------------------------
// Acerto com o escritório de cobrança — constantes (handoff 0103 §5.5).
// ---------------------------------------------------------------------------

// Filtro de conferência. O valor vai CRU para a query (`checked=true|false`);
// 'all' é ausência do param.
//
// ⚠️ "Não conferidos" é incompatível com o período: `from`/`to` filtram a data
// da CONFERÊNCIA (`checked_at`), que por definição não existe em título não
// conferido. O backend responde 422 nessa combinação em vez de devolver lista
// vazia sem explicação — e a tela impede a combinação antes disso (a mesma
// família do "filtro fantasma", navegacao.md §1.0.3).
export const CHECKED_OPTIONS = [
   { value: 'all', label: 'Conferidos e não conferidos' },
   { value: 'true', label: 'Só conferidos' },
   { value: 'false', label: 'Só não conferidos' },
];

export const CHECKED_VALUES = CHECKED_OPTIONS.map((option) => option.value);

// O período só faz sentido quando pode haver conferência no recorte.
export function allowsDateRange(checked) {
   return checked !== 'false';
}

// Paginação SERVER-SIDE (o relatório é por título e pode ser longo — diferente
// da fila da Central, que fatia no cliente uma resposta já carregada).
export const RECONCILIATION_PER_PAGE = 20;

// Teto do export no backend: acima disso a planilha traz uma linha de AVISO de
// truncamento no final e o gestor precisa estreitar o período.
export const EXPORT_ROW_LIMIT = 5000;
